import { Navigate } from "react-router-dom";

const CallCenterSettingsPage = () => (
  <Navigate to="/call-center/ticket-settings?tab=statuses" replace />
);

export default CallCenterSettingsPage;
